// src/components/Premium/Premium.js
import React from 'react';
import { FiCheck, FiArrowRight } from 'react-icons/fi';
import styled from 'styled-components';
import { fadeIn } from '../shared/animations';
import Button from '../shared/Button';
import { Link } from 'react-router-dom';

// Styled Components
const PremiumContainer = styled.section`
  padding: 100px 20px;
  background: linear-gradient(135deg, #151c48 0%, #2a3a8f 100%);
  color: white;
  text-align: center;
  
  @media (max-width: 768px) {
    padding: 60px 20px;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;


const PremiumCard = styled.div`
  background: white;
  border-radius: 16px;
  max-width: 1000px;
  margin: 0 auto;
  padding: 60px;
  box-shadow: 0 30px 60px -10px rgba(0, 0, 0, 0.2);
  color: #151c48;
  animation: ${fadeIn} 0.8s ease-out;
  
  @media (max-width: 768px) {
    padding: 30px 20px;
  }
`;

const PremiumTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 30px;
  font-weight: 800;
  color: #151c48;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const PremiumSubtitle = styled.p`
  font-size: 1.2rem;
  margin-bottom: 30px;
  color: #5f6c84;
`;

const PremiumFeatures = styled.ul`
  text-align: left;
  max-width: 600px;
  margin: 0 auto 40px;
  list-style: none;
`;

const PremiumFeature = styled.li`
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
  font-size: 1.1rem;
  
  svg {
    color: #5ab9d3;
    margin-right: 15px;
    flex-shrink: 0;
    margin-top: 3px;
  }
`;

// Data - Pode ser movido para um arquivo separado se necessário
const PREMIUM_FEATURES = [
  'Consultoria individual com especialista em relocation',
  'Planejamento completo da mudança (documentos, moradia, escolas, etc.)',
  'Visitas virtuais a imóveis e bairros',
  'Auxílio na abertura de conta bancária portuguesa',
  'Suporte na obtenção de NIF e seguro saúde',
  'Orientação para matrícula escolar e reconhecimento de diplomas',
  'Assessoria para procura de emprego em Portugal'
];

// Componente Principal
const Premium = () => {
  return (
    <PremiumContainer id="premium">
      <Container>
        <PremiumCard>
          <PremiumTitle>Serviço dos parceiros Realoca Fácil</PremiumTitle>
          <PremiumSubtitle>
            Para quem busca uma experiência completa e personalizada em sua realocação para Portugal.
          </PremiumSubtitle>
          
          <PremiumFeatures>
            {PREMIUM_FEATURES.map((feature, index) => (
              <PremiumFeature key={index}>
                <FiCheck size={20} />
                <span>{feature}</span>
              </PremiumFeature>
            ))}
          </PremiumFeatures>
          
          <Button 
            as={Link} 
            to="/relocation-form" 
            primary 
            style={{ margin: '0 auto' }}
          >
            Quero o serviço<FiArrowRight />
          </Button>
        </PremiumCard>
      </Container>
    </PremiumContainer>
  );
};

export default Premium;